export const amplifyConfig = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID
};

export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
};

export const apiAdfsConfig = {
  instance: process.env.REACT_APP_INSTANCE_ADFS,
  tenant: "adfs",
  clientId: process.env.REACT_APP_CLIENTID_ADFS,
  redirectUrl: process.env.REACT_APP_URL,
  // redirectUrl: "http://localhost:3000",
  postLogoutRedirectUri: process.env.REACT_APP_URL,
  cacheLocation: "localStorage"

  // appId:"c46f984f-a694-4578-a776-8bfa94ad6425",
  // redirectUrl: "http://localhost:3000",
  // authority:"https://login.microsoftonline.com/online.vhu.edu.vn",
  // scopes:['user.read']

  // appId:"effa2900-8b58-42cf-8e55-ab90bbb34130",
  // redirectUrl: "http://localhost:3000",
  // authority:"https://login.microsoftonline.com/taminhtungoutlook.onmicrosoft.com",
  // scopes:['user.read']
};

export const apiconfig ={
    baseURL:process.env.REACT_APP_API_URL,
    // baseURL:"https://localhost:44316/api/",
    apiKey:process.env.REACT_APP_APIKEY,
    clientId:process.env.REACT_APP_CLIENTID
}


const Authconfig=() =>{

    let AuthenticateData =JSON.parse(localStorage.getItem("authorizationData"));
    if(AuthenticateData){
        return{
            Username :AuthenticateData.FullName,
            Role :AuthenticateData.Role,
            GraduateLevel:AuthenticateData.GraduateLevel,
            IsAuth:true,
            IsLoginAdfs:AuthenticateData.LoginType
        }
    }
    return {};
}

export default Authconfig;

// export function Authconfig = () =>{
    
//         Username :AuthenticateData? AuthenticateData.FullName: null,
//         Role :AuthenticateData? AuthenticateData.Role : null
// }